module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3VNrA7/tc-custom/9781398433489.jpg?1705539895820",
      "alt": "This image is the cover for the book Sitting Down With Evil"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sitting Down With Evil\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("West Belfast, 1972. The government has lost control. The streets of Northern Ireland are on fire, with violence escalating on both sides. Lance Corporal Owen Twill is snatched up by the IRA and held captive for ten days. On his release he leaves the army and returns to England, a broken and bitter man, obsessed with visiting revenge on the Provo commander responsible for his injuries. "), _c('br'), _vm._v("It’s 2016, and one by one, members of Owen Twill's old unit are dying in suspicious circumstances. When he learns the dark secret behind his betrayal, a chain of events is set in motion, the aftermath of which is felt from Belfast to New York City. "), _c('br'), _vm._v("As he tracks down former colleagues, he uncovers a powerful cabal with tentacles that reach to the corridors of Westminster. A conspiracy that pitches friend against friend in a battle to be the last man standing.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charlie Palmer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Charlie Palmer is a 50-year-old voluntary worker who fills his days apologising for a big-boned Labrador. He has previously had a short story published, but Sitting Down with Evil is his first novel. "), _c('br'), _vm._v("He lives in Colchester with his wife Emma. His two sons, Louis and Oli, have flown the coop for university studies. In his spare time, Charlie follows Formula 1 and travels to satisfy his Epicurean urges. Needless to say, 2020 remains a constant source of disappointment to him.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0